export async function discardSite(siteId: string): Promise<void> {
  const response = await fetch(`/api/sites/${siteId}/discard`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
  });

  if (!response.ok) {
    const data = await response.json().catch(() => ({ error: "Discard failed" }));
    throw new Error(data.error || "Discard failed");
  }
}
